import { render } from "./FormAlert.vue?vue&type=template&id=ecca8b06"
import script from "./FormAlert.vue?vue&type=script&lang=js"
export * from "./FormAlert.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\IvanDev\\Documents\\Projects\\mybrand\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__